import { render, staticRenderFns } from "./FileEdit.vue?vue&type=template&id=09fe5d4c&scoped=true&lang=pug&"
import script from "./FileEdit.vue?vue&type=script&lang=js&"
export * from "./FileEdit.vue?vue&type=script&lang=js&"
import style0 from "./FileEdit.vue?vue&type=style&index=0&id=09fe5d4c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe5d4c",
  null
  
)

export default component.exports